import React from "react";
import Typography from "../../../../../../components/Typography/Typography";
import TextField from "../../../../../../components/forms/TextField";
import UnifiedFileUpload from "../../../../../../components/forms/UnifiedFileUpload";

const ProfitDedicationSection = ({
    initialValues,
    topImage,
    bottomImage,
    handleTopImageSelected,
    handleBottomImageSelected,
}) => {
    return (
        <div className="mb-4">
            <Typography variant="h5" className="mb-3">
                Section 2
            </Typography>

            <div className="mb-3">
                <UnifiedFileUpload
                    name="profitSectionTopImage"
                    label="Section Image"
                    fileType="image"
                    initialFile={
                        initialValues?.profit_section_image_top_file_url
                            ? {
                                  url: initialValues?.profit_section_image_top_file_url,
                                  name: initialValues?.profit_section_image_top_file_name,
                                  isExisting: true,
                              }
                            : null
                    }
                    selectedFile={topImage}
                    onFileSelected={handleTopImageSelected}
                />
            </div>

            <div className="mb-3">
                <TextField name="profit_section_title" label="Title Text" />
            </div>

            <div className="mb-3">
                <TextField
                    name="profit_section_highlighted_percentage"
                    label="Highlighted Percentage"
                    placeholder="15"
                />
            </div>

            <div className="mb-3">
                <TextField
                    name="profit_section_highlighted_text"
                    label="Text Following Percentage"
                />
            </div>
        </div>
    );
};

export default ProfitDedicationSection;
